import "../../chunks/chunk.O2GMJYSL.js";
import "../../chunks/chunk.O2GMJYSL.js";
import {
  registerIconLibrary
} from "../../chunks/chunk.PZJQ42VP.js";
import {
  getBasePath
} from "../../chunks/chunk.BLF5UWQW.js";
import "../../chunks/chunk.T3VOOO5F.js";
import "../../chunks/chunk.ITP2OIIW.js";
import "../../chunks/chunk.H7XADNZ7.js";
import "../../chunks/chunk.Z4OOI5NQ.js";
import "../../chunks/chunk.T2TZXRAJ.js";
import "../../chunks/chunk.5E26GMTR.js";
import "../../chunks/chunk.3PRAXUFA.js";
import "../../chunks/chunk.7RPYXGIF.js";
import "../../chunks/chunk.K2NRSETB.js";

// src/components/icon/icon-library.ts
function registerFontAwesome(options) {
  const pathSegment = (options == null ? void 0 : options.disableIconsSegment) ? "" : "icons/";
  const iconMap = {
    alarm: "solid/bell",
    "arrow-down": "solid/arrow-down",
    "person-fill": "solid/user",
    "caret-right-fill": "solid/caret-right",
    check: "solid/check",
    check2: "solid/check",
    "chevron-left": "solid/chevron-left",
    "chevron-right": "solid/chevron-right",
    "chevron-down": "solid/chevron-down",
    eye: "solid/eye",
    "eye-slash": "solid/eye-slash",
    "funnel-fill": "solid/filter",
    "grip-vertical": "solid/grip-vertical",
    "star-fill": "solid/star",
    "three-dots": "solid/ellipsis",
    x: "solid/xmark",
    "x-circle": "solid/circle-xmark",
    "x-lg": "solid/x",
    "x-circle-fill": "solid/circle-xmark"
  };
  const baseLibrary = {
    resolver: (name) => `${getBasePath()}/${pathSegment}${iconMap[name] || name}.svg`,
    mutator: (svg) => svg.setAttribute("fill", "currentColor")
  };
  registerIconLibrary("default", baseLibrary);
  registerIconLibrary("system", baseLibrary);
  function createFontAwesomeLibrary(library) {
    registerIconLibrary(library, {
      resolver: (name) => `${getBasePath()}/${pathSegment}${library}/${name.replace("fa-", "")}.svg`,
      mutator: (svg) => svg.setAttribute("fill", "currentColor")
    });
  }
  createFontAwesomeLibrary("solid");
  createFontAwesomeLibrary("regular");
  createFontAwesomeLibrary("light");
  createFontAwesomeLibrary("duotone");
  createFontAwesomeLibrary("brands");
}
export {
  registerFontAwesome
};
